import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import useDynamicComponent from "../../components/dynamics/useDynamicComponent";

export default function AssistanceList() {
    const MainContent = useDynamicComponent("AssistanceWorkshopList");

    return (
        <Layout>
            <div className="pageHeader">
                <PageTitle title={`Assistências`} allowGoBack={true} />
            </div>

            {MainContent}
        </Layout>
    );
}
